// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cnvN","label":"styles_label__3JfA0"};